import {Component, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap";
import {ApiService, ExcelService, ModesEnum, OrderStatesEnum, ReconcileDto, BalanceService} from "../../../../../../projects/accounting/src/public_api";
import {DatePipe, DecimalPipe} from "@angular/common";

declare var $: any;


interface BalanceInterface {
    collected: Array<any>,
    period: string,
    senders: Array<any>
}


@Component({
    selector: 'app-balance-popup',
    templateUrl: './balance-popup.component.html',
    styleUrls: ['./balance-popup.component.scss']
})
export class BalancePopupComponent implements OnInit {
    data: BalanceInterface = null;
    files = {
        gateway: {
            input: null,
            fileUpload: null,
            fileData: []
        }
    };

    sender: string = null;
    message = '';
    checkData = null;
    loading = false;

    constructor(
        public bsModal: BsModalRef,
        private excel: ExcelService,
        private decimal: DecimalPipe,
        private api: ApiService,
        private datePipe: DatePipe,
        private balance: BalanceService,
    ) {

    }

    ngOnInit() {
        this.data.collected.forEach(i => {
            let ids = JSON.parse(i.Notes);
            if (typeof ids == 'object') {
                for (let k in ids) {
                    i[k] = ids[k];
                }
            }
        });


    }

    resetFiles() {
        this.files = {
            gateway: {
                input: null,
                fileUpload: null,
                fileData: [],
            }
        };
    }

    handleGatewayFileInput(files: FileList) {
        this.message = '';
        this.files.gateway.fileUpload = files.item(0);
    }

    changeSender() {
        this.checkData = null;
        this.resetFiles();
    }

    close() {
        this.bsModal.hide();
    }

    checkGateway() {

        if (this.sender == null) {
            this.message = 'Vui lòng chọn hình thức thanh toán';
            return;
        }
        if (this.files.gateway.fileUpload == null) {
            this.message = 'Vui lòng chọn file đối soát!';
            return;
        }
        this.loading = true;
        this.checkData = {
            joint: [],
            notJoint: []
        };
        this.excel.getDataFromFile(this.files.gateway.fileUpload, rs => {
            if (rs && Array.isArray(rs)) {
                if (this.sender == 'VNPay') {
                    let keyWizard = {
                        id: {index: '__EMPTY_2', validator: (i) => true},
                        vpTerminalID: {index: 'BÁO CÁO TỔNG HỢP GIAO DỊCH', required: true, validator: (i) => {return typeof i == "string" && i.indexOf('AHA') != -1}},
                        vpStoreID: {index: '__EMPTY_3', required: true, validator: (i) => {return typeof i == "string" && i.indexOf('AHA') != -1}},
                        qty: {index: '__EMPTY_4',  required: true,validator: (i) => {return !isNaN(Number(i))}},
                        amount: {index: '__EMPTY_5', required: true, validator: (i) => {return !isNaN(Number(i))}},
                    };
                    let fileData = this.balance.getAllRecord(rs, keyWizard);
                    let resultCompare = this.balance.handleCompare({arr1: this.data.collected, arr2: fileData}, {vpTerminalID: 'vpTerminalID'}, {VNPay: 'amount'});
                    resultCompare.joint.forEach(i => {
                        this.checkData.joint.push({
                            Receiver: i.a.Receiver,
                            Sender: this.sender,
                            Amount: i.a.VNPay,
                            CheckAmount: i.b.amount,
                            CapitalID: i.a.ID,

                        })
                    });
                    resultCompare.notJoint.forEach(i => {
                        this.checkData.notJoint.push({
                            Receiver: i.a == null ? i.b.vpStoreID : i.a.Receiver,
                            Sender: this.sender,
                            Amount: i.a == null ? 0 : i.a.VNPay,
                            CheckAmount: i.b == null ? 0 : i.b.amount,
                            CapitalID: i.a == null ? null : i.a.ID,
                        })
                    })
                }
            }
            this.loading = false;
        })
    }

    handleOrdersFileInput(files: FileList, item) {
        this.loading = true;
        item.fileUpload = files.item(0);
        this.excel.getDataFromFile(files.item(0), rs => {
            console.log(rs);
            if (rs && Array.isArray(rs)) {
                if (this.sender == 'VNPay') {
                    let keyWizard = {
                        id: {index: 'BÁO CÁO CHI TIẾT GIAO DỊCH', validator: (i) => true},
                        vpTerminalID: {index: '__EMPTY', required: true, validator: (i) => {return typeof i == "string" && i.indexOf('AHA') != -1}},
                        vpStoreID: {index: '__EMPTY_1', required: true, validator: (i) => {return typeof i == "string" && i.indexOf('AHA') != -1}},
                        tradingCode: {index: '__EMPTY_2', validator: (i) => true},
                        billNumber: {index: '__EMPTY_3', required: true, validator: (i) => {return typeof i == "string" && i.length > 0}},
                        mtt: {index: '__EMPTY_4', validator: (i) => true},
                        mkm: {index: '__EMPTY_6', validator: (i) => true},
                        amount: {index: '__EMPTY_7', required: true, validator: (i) => {return !isNaN(Number(i))}},
                        amountAfter: {index: '__EMPTY_8', validator: (i) => {return !isNaN(Number(i))}},
                        bank: {index: '__EMPTY_11', validator: (i) => true},
                        date: {index: '__EMPTY_14', validator: (i) => true},
                        status: {index: '__EMPTY_15', validator: (i) => true},
                    };
                    let fileData = this.balance.getAllRecord(rs, keyWizard);
                    let since, until;
                    fileData.forEach(r => {
                        let time = this.dateStringToTimeStamp(r.date);
                        if (time != null) {
                            if (!since || since > time) {
                                since = time;
                            }
                            if (!until || time > until) {
                                until = time;
                            }
                        }
                    });
                    if (since && until) {
                        let body = {
                            ID: item.CapitalID,
                            Since: this.datePipe.transform(new Date().setTime(since), 'dd-MM-yyyy'),
                            Until: this.datePipe.transform(new Date().setTime(until), 'dd-MM-yyyy'),
                            Gateway: OrderStatesEnum.VNPay,
                            Mode: ModesEnum.Transactions,
                        };
                        this.api.reconcile(body).subscribe(rs => {
                            if (rs.succeed && rs.data) {
                                rs.data.forEach( i => {
                                    let extra = JSON.parse(i.Receiver);
                                    for(let key in extra){
                                        i[key] = extra[key]
                                    }
                                    i.Status = 'Thành công';
                                });
                                let ordersData = rs.data;
                                console.log('file data',fileData);
                                let a = 0;
                                fileData.forEach( kx => {
                                    a += kx.amount;
                                });
                                console.log('tong', a);
                                let resultCompare = this.balance.handleCompare({arr1: ordersData, arr2: fileData}, {Notes: 'billNumber'}, {Amount: 'amount', Status: 'status'});
                                let excelFileName = 'Chi tiết các giao dịch không khớp ' + item.Receiver + '_' + this.sender + '_T' + this.data.period;
                                let excelFileData = [];
                                let index = 1;
                                console.log(resultCompare);
                                resultCompare.notJoint.forEach( i => {
                                    excelFileData.push({
                                        'STT': index,
                                        'Mã điểm bán': i.a != null ? i.a.vpTerminalID : i.b.vpTerminalID,
                                        'Tên điểm bán': i.a != null ? i.a.vpStoreID : i.b.vpStoreID,
                                        'Mã GD': i.b != null ? i.b.tradingCode : 'KXĐ',
                                        'Số hóa đơn': i.b != null ? i.b.billNumber : i.a.Notes,
                                        'Mã thanh toán': i.b != null ? i.b.mtt : 'KXĐ',
                                        'Ngày đặt hàng': i.b != null ? i.b.date: 'KXĐ',
                                        'Số tiền trước KM': i.b != null ? i.b.amount : 0 ,
                                        'Số tiền sau KM': i.b != null ? i.b.amountAfter : 0 ,
                                        'Tiền AHA ghi nhận': i.a != null ? i.a.Amount : 0
                                    });
                                    index ++;
                                });
                                this.excel.exportAsExcelFile(excelFileData, excelFileName);
                                this.loading = false;
                            } else {
                                this.loading = false;
                            }
                        })
                    } else {
                        this.loading = false;
                    }

                }
            }
        })
    }
    dateStringToTimeStamp(dateString) {
        let dsArr = dateString.split(' ');
        if (dsArr.length != 2) return null;
        let years = dsArr[0].split('/');
        if (years.length != 3) return null;
        let time = new Date();
        time.setFullYear(years[2], years[1] - 1, years[0]);
        return time.getTime();
    }

    getDisplayName(i) {
        let first = i.Receiver.split(',')[0];
        return '<b>' + first + '</b><br><small>' + i.Receiver.substr(first.length + 1) + '</small>';
    }

    getDisplayWarning(i) {
        if (i.Amount > i.CheckAmount) {
            return '<span class="text-danger">' + 'Thiếu ' + this.decimal.transform(i.Amount - i.CheckAmount, '1.0-0', 'en-US') + '</span>'
        } else {
            return '<span class="text-warning">' + 'Thừa ' + this.decimal.transform(i.CheckAmount - i.Amount, '1.0-0', 'en-US') + '</span>'
        }
    }

    toogleElement(event, className) {
        let target = $(event.target);
        let el = target.hasClass(className) ? target : target.parents(className);
        if (el.hasClass('active')) {
            el.removeClass('active');
        } else {
            el.addClass('active');
        }
    }

}

